<template lang="pug">
div
    .w-full.draw-area(style="height:400px")
        .block.box-map(v-if="load_data_status_recent_location_es_list === 'loading'")
            //- Loading(show="true")
            Spinner(show="true" size="48")

        //- .block.box-map.bg-gray-200(v-else)
        template(v-else)
            template(v-if="mapLoaded")

                l-map(v-if="vendorMap==='osm'"  ref="mapRefOSM" :id="idOsm" :zoom="10" :center="center" :options="options" style="height: 100%;width: 100%;")
                    l-tile-layer(:url="url" :attribution="attribution")
                    l-marker(v-for="(location, index) in locations" :lat-lng="location.position" v-bind:key="index" :icon="getMarkerOsmIcon(location)")
                        l-popup(:content="location.name")

                gmap-map(v-else ref="mapRef" :center="center" :zoom="11" :options="options" style="width:100%; height: 100%;")
            
            .block.box-map(v-else)
                NoDataAvailable
            //- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.1738240507757!2d110.37531111477065!3d-7.771384694399184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a59b2d4729729%3A0xac4d7b5fcf34f8e4!2sGadjah%20Mada%20University!5e0!3m2!1sen!2sid!4v1591602090544!5m2!1sen!2sid" width="100%" height="100%" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
    hr.mt-8.mb-3
    .block.items-center.justify-between(
        class="lg:p-0 p-4 lg:flex"
    )
        .result-filter__info.w-full.mobile-only.mb-4
            .list.flex.items-center.justify-between.mb-3.pb-3.border-b
                strong Showing data
                div.btn-primary-o.btn-small(
                    v-on:click="filterShow = !filterShow"
                ) Filter

            .list.flex.items-center.justify-between.mb-2
                span Date
                strong.monospace {{ dateRange.startDate | date}} - {{ dateRange.endDate  | date}}
            
            .list.flex.items-center.justify-between
                span Show
                strong.monospace {{ items_per_page }}

        .result-filter__action(
            v-bind:class="{'is-show' : filterShow}"
        )
            .mobile-only
                .header-filter.mb-4
                    h2 Filter
                    button(
                        v-on:click="filterShow = !filterShow"
                    )
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            .flex.items-center
                .flex.flex-wrap.items-center.justify-between
                    .relative.mr-3.field-date-time-picker
                        date-range-picker(
                            v-if="dateRange.startDate && dateRange.endDate" 
                            ref="picker" 
                            v-model="dateRange" 
                            @update="pickerUpdate($event)" 
                            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                            :date-format="dateFormat" 
                            opens="right" 
                            :ranges="default_ranges"
                            autoApply=true)
                            div(
                                slot="input" 
                                slot-scope="picker") 
                                    | {{ picker.startDate | date}} - {{ picker.endDate  | date}}

                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

                    .flex.flex-wrap.items-center
                        .field.mr-2.relative
                            select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            .mobile-only
                button.btn-primary-o.w-full.btn-large(
                    v-on:click="filterShow = !filterShow"
                ) Filter
        .block(v-if="recent_location_es_list.data && recent_location_es_list.data.length > 0")
            .flex.flex-wrap.items-center.justify-between
                .field.mr-3.relative
                //- JsonCSV(
                //-     :data="csvData"
                //-     :name="csvName"
                //-     class="btn btn-primary"
                //- )
                //-     | Download CSV

                JsonExcel.btn.btn-primary.cursor-pointer(
                    type = "csv"
                    :title="[('Location History '+ (single_target_detail.target_name ? '- '+ single_target_detail.target_name : '') +' - Target Detail' ), from_date + ' - ' + to_date]"
                    :name="csvName"
                    :data="csvData"
                )
                    | Download CSV
    
    .table-static.w-full.py-4
        table.table-general
            thead
                tr
                    th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
            tbody
                tr(v-if="load_data_status_recent_location_es_list === 'loading'")
                    td.text-center(:colspan="tableThead.length")
                        .flex.flex-wrap.items-center.justify-center
                            Spinner(show="true" size="48")
                        
                template(v-else-if="recent_location_es_list.data && recent_location_es_list.data.length > 0")
                    tr(v-for="(data,index) in recent_location_es_list.data" :key="data.id")
                        //- td {{getTargetName(data.features[0].properties.msisdn)}}

                        //- old
                        //- td {{data.features[0].properties.msisdn}}
                        //- td 
                            small {{data.features[0].properties.alamat ? data.features[0].properties.alamat : '-'}}
                        //- td 
                            small {{data.features[0].properties.dtm}}
                        //- td 
                            small {{data.features[0].properties.requested_at}}

                        //- new
                        td {{ data.features && data.features[0].properties && data.features[0].properties.msisdn ? data.features[0].properties.msisdn : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.bts ? data.features[0].properties.bts : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.state ? data.features[0].properties.state : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.tac ? data.features[0].properties.tac : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.enb ? data.features[0].properties.enb : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.lac ? data.features[0].properties.lac : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.ci ? data.features[0].properties.ci : '-' }}
                        //- td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.imei ? data.features[0].properties.imei : '-' }}
                        td 
                            small {{ data.features && data.features[0].properties && data.features[0].properties.alamat ? data.features[0].properties.alamat : '-' }}

                        td(v-if="data.features && data.features[0].properties && data.features[0].properties.status" :class="data.features[0].properties.status.toLowerCase()==='successfully' ? 'status-active' : 'status-inactive'")
                            | {{ data.features[0].properties.status }}
                        td(v-else) -

                        td {{ data.features && data.features[0].properties && data.features[0].properties.dtm ? data.features[0].properties.dtm : '-' }}
                                td {{ data.features && data.features[0].properties && data.features[0].properties.requested_at ? data.features[0].properties.requested_at : '-' }}

                        td.text-center
                            div.inline-flex.items-center
                                template(v-if="data.features[0].geometry.coordinates[0]")
                                    a.btn-small.btn-default.ml-2(:href="'https://www.google.com/maps?q='+data.features[0].geometry.coordinates[1]+','+data.features[0].geometry.coordinates[0]" target='_blank' v-tooltip="'Google Maps'")
                                        div.text-gray-500
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                                template(v-else)
                                    | -

                tr(v-else)
                    td.text-center(:colspan="tableThead.length") No Data Available
        .mt-5
        vue-ads-pagination(
            :total-items="total_data"
            :items-per-page="items_per_page"
            :page="page"
            :max-visible-pages="5"
        )
            template(slot="buttons" slot-scope="props")
                vue-ads-page-button(
                    v-for="(button, key) in props.buttons"
                    :key="key"
                    v-bind="button"
                    :class="{'bg-yellow-dark': button.active}"
                    @page-change="page = button.page"
                    @range-change="start = button.start; end = button.end"
                )
</template>

<script>
import { mapState } from 'vuex';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import moment from 'moment';
import JsonCSV from 'vue-json-csv';
import JsonExcel from "vue-json-excel";
import { decrypt } from '@/util/crypto';
import { gmapApi } from 'vue2-google-maps';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
// import Loading from '@/components/Loading.vue';

// openmapstreet
import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet';
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.imagePath = ''
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

export default {
    name: 'STLocationHistory',
    components: {
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        DateRangePicker,
        JsonCSV,
        JsonExcel,
        NoDataAvailable,
        // Loading,

        // opemapstreet
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
    },
    data() {
        return {
            filterShow: false,
            tableThead: [
                // {
                //     name: 'Target',
                // },
                {
                    name: 'MSISDN',
                },{
                    name: 'BTS ID',
                },{
                    name: 'State',
                },{
                    name: 'TAC',
                },{
                    name: 'ENB',
                },{
                    name: 'LAC',
                },{
                    name: 'CI',
                },{
                //     name: 'IMEI',
                // },{
                    name: 'Location',
                },{
                    name: 'Status',
                },{
                    name: 'Datetime',
                },{
                    name: 'Requested At',
                },{
                    name: 'Maps',
                    action: true,
                },
            ],
            
            // optFilterTarget: [],
            // filterTarget: '',
            paramMsisdn: [],
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            keyword: '',
            timeout: null,

            from_date: '',
            to_date: '',

            dateRange: {
                startDate: '',
                endDate: '',
            },
            default_ranges: {
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],
                'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },
            // csvName: 'location_history_list_'+moment().format('YYYY-MM-DD_HH:mm:ss')+'.csv',
            csvData: [],

            // map
            options: {
                // zoomControl: true,
                // mapTypeControl: true,
                // scaleControl: true,
                // streetViewControl: true,
                // rotateControl: true,
                // fullscreenControl: false,
                // disableDefaultUi: false
                // scrollwheel: false,
                gestureHandling: 'cooperative',
                styles: [
                    {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                    {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                    {
                        featureType: 'administrative.locality',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}]
                    },
                    {
                        featureType: 'poi',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'geometry',
                        stylers: [{color: '#263c3f'}]
                    },
                    {
                        featureType: 'poi.park',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#6b9a76'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry',
                        stylers: [{color: '#38414e'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#212a37'}]
                    },
                    {
                        featureType: 'road',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#9ca5b3'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry',
                        stylers: [{color: '#746855'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'geometry.stroke',
                        stylers: [{color: '#1f2835'}]
                    },
                    {
                        featureType: 'road.highway',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#f3d19c'}]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'geometry',
                        stylers: [{color: '#2f3948'}]
                    },
                    {
                        featureType: 'transit.station',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#d59563'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'geometry',
                        stylers: [{color: '#17263c'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.fill',
                        stylers: [{color: '#515c6d'}]
                    },
                    {
                        featureType: 'water',
                        elementType: 'labels.text.stroke',
                        stylers: [{color: '#17263c'}]
                    }
                ],
            },
            infoWindows: [],
            mapLoaded: false,
            center: {},
            markers: [],
            // places: [],
            // heatmap: null,
            mapsLatLng: [],
            polyline: null,

            marker_color: {
                green: '#48bb78',
                red: '#f56565',
                purple: '#9f7aea',
                orange: '#ed8936',
                blue: '#4299e1',
            },

            isAstro: process.env.VUE_APP_ASTRO,

            vendorMap: (typeof process.env.VUE_APP_VENDOR_MAP!==undefined || typeof process.env.VUE_APP_VENDOR_MAP!=='undefined'? process.env.VUE_APP_VENDOR_MAP: 'gmap'),

            // openmapstreet
            // url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
            url: `${process.env.VUE_APP_OSM_CDN_URL}{z}/{x}/{y}.png`,
            attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            locations: [],
            idOsm: 'openmapstreet-detail_target',
            newLoc: '',
            newLt : 0, 
            newLng : 0,
            icon: L.icon({iconUrl: "null",}),
        }
    },
    computed: {
        ...mapState([
            'load_data_status_recent_location_es_list',
            'recent_location_es_list',
            'single_tracking_detail',
            'single_target_detail',
        ]),
        route_name() {
            return this.$route.name;
        },
        id() {
            return this.$route.params.id;
        },
        key() {
            return decrypt(this.$route.params.key).split('&&');
        },
        google: gmapApi,
        csvName() {
            return 'location_history_list'+ (this.single_target_detail.target_name ? '-'+ (this.single_target_detail.target_name).toLowerCase().replace(' ', '_') : '') + '-target_detail' + moment().format('YYYY-MM-DD_HH:mm:ss')+'.csv';
        },
    },
    watch: {
        load_data_status_recent_location_es_list(newData){
            if (newData !== 'loading') {
                this.startMap()
            }
        },
        recent_location_es_list(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);

                if (newData.data && newData.data.length > 0) {
                    this.getDataCsv(newData.data);
                }
            } else {
                this.total_data = 0;
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        keyword() {},
        single_tracking_detail() {
            // if (this.single_tracking_detail != undefined && this.single_tracking_detail.target != undefined) {
            //     this.setData(this.single_tracking_detail)
            // }
        },
        // filterTarget(){
        //     this.getData();
        // },
        // id() {
        //     if (this.id != undefined) {
        //         this.getData();
        //     }
        // },
        route_name(newData, oldData) {
            if (newData === 'PageTargetDetailHome') {
                if (oldData !== 'PageTargetDetailHome') {
                    // this.dateRange.startDate = moment().toDate();
                    // this.dateRange.endDate = moment().toDate();

                    // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    const default_date = this.$store.getters.getDefaultDate();

                    this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                    this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                    this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                    this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                    // this.optFilterTarget= []
                    // this.filterTarget= ''
                    this.paramMsisdn= []
                    this.items_per_page = 10
                    this.page = 0
                    this.keyword = ''
                    this.$store.commit('setSingleMonitoringList', {})
                    this.$store.commit('setLoadDataStatusSingleMonitoringList', 'loading')
                }

                // if (this.single_tracking_detail != undefined && this.single_tracking_detail.target != undefined) {
                //     this.setData(this.single_tracking_detail)
                // }
                
                this.getData();
            }
        },
        id() {},
        key() {},
        google() {},
        csvName() {},
    },
    methods: {
        datetimeFormat(datetime) {
            return moment(datetime, 'YYYY-MM-DDThh:mm:ssZ').format('DD MMM YYYY HH:mm:ssZ');
        },
        /* eslint-disable no-unused-vars */
        dateFormat (classes, date) {
            if (!classes.disabled) {
                // console.log('on dateFormat')
                // console.log(moment(date.getTime())._d)

                // classes.disabled = date.getTime() > new Date();
                classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
            }
            return classes;
        },
        // detailMaps(id) {
        //     console.log(id)
        // },
        getData() {
            var msisdn = this.key[0];
            // if (this.filterTarget) {
            //     msisdn = this.filterTarget
            // } else {
            //     msisdn = JSON.stringify(this.paramMsisdn)
            // }
            this.$store.commit('setRecentLocationESList', {});
            this.$store.dispatch('getRecentLocationES', [msisdn, this.items_per_page, (this.page + 1), this.from_date, this.to_date, 'single'])
            .then(() => {
                this.startMap();
            });

            // console.log('get data log location history')
            
            // if (this.recent_location_es_list.data && this.recent_location_es_list.data.length > 0) {
            //     this.getDataCsv(this.recent_location_es_list.data)
            // }
            if (this.recent_location_es_list.total_page && this.recent_location_es_list.total_page > 1) {
                // console.log(this.recent_location_es_list.total_page)
                this.pagination();
            }
        },
        getDataCsv(data) {
            this.csvData = data.map((item) => {
                return {
                    // target_name  : this.getTargetName(item.features[0].properties.msisdn),
                    msisdn       : item.features[0].properties.msisdn?item.features[0].properties.msisdn:'-',
                    bts_id: item.features[0].properties.bts ? item.features[0].properties.bts : '-',
                    state: item.features[0].properties.state ? item.features[0].properties.state : '-',
                    tac: item.features[0].properties.tac ? item.features[0].properties.tac : '-',
                    enb: item.features[0].properties.enb ? item.features[0].properties.enb : '-',
                    lac: item.features[0].properties.lac ? item.features[0].properties.lac : '-',
                    ci: item.features[0].properties.ci ? item.features[0].properties.ci : '-',
                    // imei: item.features[0].properties.imei ? item.features[0].properties.imei : '-',
                    status: item.features[0].properties.status ? item.features[0].properties.status : '-',
                    location_name: item.features[0].properties.alamat ? item.features[0].properties.alamat : '-',
                    coordinates  : item.features[0].geometry.coordinates[0]?item.features[0].geometry.coordinates[1]+','+item.features[0].geometry.coordinates[0]:'-',
                    datetime     : item.features[0].properties.dtm?item.features[0].properties.dtm:'-',
                 };
            })
        },
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        searchKeyword() {
            // clear timeout variable
            clearTimeout(this.timeout);
            
            var self = this;
            this.timeout = setTimeout(function () {
                // enter this block of code after 1 second
                // handle stuff, call search API etc.
                self.page = 0;
                self.$store.commit('setMultiTrackingList', {});

                // if (self.keyword.length > 0) {
                    self.getData();
                // }
            }, 650);
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null) {
            this.$swal.fire({
                title: 'Failed!',
                text: (message!==null ? message : 'Something wrong.'),
                icon: 'error',
                // timer: 3000
            });
        },
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        async pickerUpdate(e) {
            // console.log('========= DateRangePicker on update')
            // console.log(e)

            let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;

            if (this.isAstro !== 'true' && ranges > 7) {
                const default_date = this.$store.getters.getDefaultDate();

                // this.dateRange.startDate = moment().toDate();
                // this.dateRange.endDate = moment().toDate();

                // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.$swal.fire({
                    icon: 'error',
                    title: 'Date range is not more than 7 days!',
                    text: 'Your date range is ' + ranges + ' days.',
                    // confirmButtonText: 'Yes!',
                    // confirmButtonColor: '#DD6B55',
                    // showCancelButton: true,
                    // allowOutsideClick: false,
                })

                // return;
            } else {
                this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                this.getData();
            }
        },
        hideAllInfoWindows() {
            for (var j=0; j < this.infoWindows.length; j++) {
                this.infoWindows[j].close();
            }
        },
        getMarkerOsmIcon(location){
            let iconColor = '#ffffff'
            if (location.iconColor){
                iconColor = location.iconColor
            }
            let stroke_width = '1.4';
            let stroke = 'black';
            // let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="black" stroke-width="3"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="black" stroke-width="3" stroke-linejoin="round"/></svg>'
            let mySvgString = '<svg width="64" height="64" viewBox="0 0 64 64" fill="<color-icon>" xmlns="http://www.w3.org/2000/svg"><path d="M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'"/><path d="M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z" fill="<color-icon>" stroke="'+ stroke +'" stroke-width="'+ stroke_width +'" stroke-linejoin="round"/></svg>'
            // let myIconUrl = encodeURI("data:image/svg+xml," + mySvgString).replace('<color-icon>',iconColor).replace('#','%23');
            // let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replaceAll('<color-icon>',iconColor)).replaceAll('#','%23');
            let myIconUrl = encodeURI("data:image/svg+xml;utf8," + mySvgString.replace(/<color-icon>/g,iconColor)).replace(/#/g,'%23');

            return L.icon({
                iconUrl: myIconUrl,
                // iconSize: 40
                iconSize: 50,
                iconAnchor: [24.5, 49],
                popupAnchor: [0, -48],
            });
        },
        async startMap() {
            switch(this.vendorMap) {
              case 'osm':
                await this.startMapOSM();
                break;
              default:
                await this.startMapGMAP();
                break;
            }
        },
        async startMapOSM() {
            var self = this;
            
            self.locations = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                if (self.recent_location_es_list.data.length > 0) {
                    const map = self.$refs.mapRefOSM.mapObject;

                    var bounds = [];
                    
                    for (var i = 0; i < self.recent_location_es_list.data.length; i++) {

                        if (Object.keys(self.recent_location_es_list.data[i].features[0].geometry.coordinates).length > 0) {
                            let latTmp = parseFloat(self.recent_location_es_list.data[i].features[0].geometry.coordinates[1]);
                            let lngTmp = parseFloat(self.recent_location_es_list.data[i].features[0].geometry.coordinates[0]);
                            let centerTmp = [latTmp, lngTmp]
                            
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                              '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1 cell-info-window whitespace-no-wrap">MSISDN</td>'+
                                    '<td class="pr-1 cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.msisdn+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Address</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.alamat+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Datetime</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.recent_location_es_list.data[i].features[0].geometry.coordinates[1]+','+self.recent_location_es_list.data[i].features[0].geometry.coordinates[0]+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';
                            
                            self.locations.push({
                                name: contentString,
                                position: centerTmp, 
                                iconColor: self.single_target_detail.label
                            });

                            bounds.push(centerTmp);
                        }

                    }

                    if (bounds.length)
                        map.fitBounds(L.latLngBounds([bounds]));
                }
            });
        },
        async startMapGMAP() {
            var self = this;
            // var mapsLatLng = [];

            self.infoWindows = [];
            self.markers = [];
            self.mapsLatLng = [];

            // monas, jakarta
            this.center = {
                lat: -6.1763562,
                lng: 106.8227796,
            };

            this.mapLoaded = true;

            await self.$nextTick(() => {
                self.$refs.mapRef.$mapPromise.then((map) => {
                    const google = self.google;

                    // map.center = new google.maps.LatLng(self.center);

                    if (self.recent_location_es_list.data.length > 0) {
                        var bounds = new google.maps.LatLngBounds();

                        for (var i = 0; i < self.recent_location_es_list.data.length; i++) {

                            var icon = {
                                path: 'M31.5766 15.7225C35.366 15.7225 38.4379 12.6506 38.4379 8.86127C38.4379 5.07189 35.366 2 31.5766 2C27.7872 2 24.7153 5.07189 24.7153 8.86127C24.7153 12.6506 27.7872 15.7225 31.5766 15.7225Z M18 26.8175V41.4161C18 43.1679 19.4599 44.4817 21.0657 44.4817H23.9854L25.5911 59.5183C25.7372 60.9782 26.905 62 28.3649 62H34.6423C36.1022 62 37.2701 60.978 37.4161 59.5183L39.0219 44.4817H41.9416C43.6934 44.4817 45.0073 43.1679 45.0073 41.4161V26.8175C45.1533 14.9926 18 14.9926 18 26.8175Z',
                                // fillColor: self.marker_color[self.single_target_detail.label],
                                fillColor: self.single_target_detail.label,
                                fillOpacity: 1,
                                // strokeWeight: 1.2,
                                strokeWeight: 1.2,
                                strokeColor: '#ffffff',
                                // scale: 1.25,
                                scale: .65,
                                anchor: new google.maps.Point(30,65),
                            }

                            let marker = new google.maps.Marker({
                                position: {
                                    lat: parseFloat(self.recent_location_es_list.data[i].features[0].geometry.coordinates[1]),
                                    lng: parseFloat(self.recent_location_es_list.data[i].features[0].geometry.coordinates[0])
                                },
                                map: map,
                                icon: icon,
                                // draggable: true,
                            });
                            // console.log(marker);
                            self.markers.push(marker);

                            // var dtm = (self.recent_location_es_list.data[i].created_at ? self.datetimeFormat(self.recent_location_es_list.data[i].created_at) : '-');
                            
                            var contentString = '<div id="content">'+
                              '<div id="bodyContent">'+
                              '<table>'+
                                  '<tr>'+
                                    '<td class="pr-1 cell-info-window whitespace-no-wrap">MSISDN</td>'+
                                    '<td class="pr-1 cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.msisdn+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Address</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.alamat+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Datetime</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window">'+self.recent_location_es_list.data[i].features[0].properties.dtm+'</td>'+
                                  '</tr>'+
                                  '<tr>'+
                                    '<td class="cell-info-window whitespace-no-wrap">Link Location</td>'+
                                    '<td class="cell-info-window">:</td>'+
                                    '<td class="cell-info-window"><a target="_blank" href="https://www.google.com/maps?q='+self.recent_location_es_list.data[i].features[0].geometry.coordinates[1]+','+self.recent_location_es_list.data[i].features[0].geometry.coordinates[0]+'" style="color: #43ea92;">'+'Google Maps</a> '+
                                    '</td>'+
                                  '</tr>'+
                                '</table>'+
                              '</div>'+
                            '</div>';

                            let infowindow = new google.maps.InfoWindow({
                                content: contentString,
                                maxWidth: 400
                            });
                            
                            self.infoWindows.push(infowindow);
                            
                            google.maps.event.addListener(marker, 'click', function() {
                              // hideAllInfoWindows(map);
                              self.hideAllInfoWindows();
                              infowindow.open(map, marker);
                            });

                            bounds.extend(new google.maps.LatLng(marker.position.lat(), marker.position.lng()));
                        }
                        // Apply fitBounds
                        map.fitBounds(bounds); 
                    } else {
                        self.mapLoaded = false;
                    }
                });
            });
        },

        async openTab(){
            var tmpStatus = this.load_data_status_recent_location_es_list;
            await this.$store.commit('setLoadDataStatusRecentLocationESList', 'loading');
            // await this.$store.commit('setLoadDataStatusRecentLocationESList', {
            //     status: 'loading',
            //     cancel: null,
            //     code: null
            // });
            this.$store.commit('setLoadDataStatusRecentLocationESList', tmpStatus);
        },
    },
    filters: {
      date: function (date) {
        return moment(date).format('YYYY-MM-DD');
      }
    },
    created() {
        EventEmit.$on('startMapLocationHistory', () => {
            // console.log('event listen startMapLocationHistory', this.load_data_status_recent_location_es_list)
            if (this.load_data_status_recent_location_es_list !== 'loading') {
                this.openTab();
            }
        });
    },
    mounted() {
        // console.log('=================== mounted lh')
        // console.log(this.route_name)
        if (this.route_name === 'PageTargetDetailHome') {
            // reset date filter
            // this.dateRange.startDate = moment().toDate();
            // this.dateRange.endDate = moment().toDate();

            // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

            const default_date = this.$store.getters.getDefaultDate();

            this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
            this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

            this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
            this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');
            
            // if (this.single_tracking_detail != undefined && this.single_tracking_detail.target != undefined) {
            //     this.setData(this.single_tracking_detail)
            // }
            this.getData();
        }
    },
}
</script>

<style lang="sass">
    .draw-area
        height: 500px
    .cell-info-window
        vertical-align: top
</style>